angular.module('st')
    .controller('crewardsSignupController', [
        '$rootScope','$scope','$http',
        function ($rootScope, $scope, $http) {
            var ctrl = this;

            var numberOfYears = (new Date()).getYear() - 8;
            $scope.Years = $.map($(Array(numberOfYears)), function (val, i) { return i + 1900; }).reverse();
            $scope.Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            $scope.Days = $.map($(Array(31)), function (val, i) { return i + 1; });
            $scope.NumberOfDays = 31;
            $scope.formFeedback = '';
            $scope.processing = false;
            $scope.token = '';
            $scope.model = {};

            ctrl.IsLeapYear = function (selectedYear) {
                var year = selectedYear || 0;
                return ((year % 400 == 0 || year % 100 != 0) && (year % 4 == 0)) ? 1 : 0;
            }

            ctrl.GetNumberOfDaysInMonth = function (selectedMonth) {
                return 31 - ((selectedMonth === 2) ? (3 - ctrl.IsLeapYear($scope.model.DobYear)) : ((selectedMonth - 1) % 7 % 2));
            }

            ctrl.UpdateNumberOfDays = function () {
                $scope.NumberOfDays = ctrl.GetNumberOfDaysInMonth($scope.model.DobMonth);
            }

            ctrl.IsFieldInvalid = function(field) {
                return field.$invalid && (field.$touched || $scope.frm.$submitted);
            }

            ctrl.SubmitForm = function () {
                if (!$scope.frm.$valid) {
                    var position = ($('.form-container .ng-invalid').first().offset().top) - 150;
                    $('html, body').animate({
                        scrollTop: position
                    },500);
                    return;
                }
                grecaptcha.ready(function() {
                    grecaptcha.execute($('#captcha-site-key').val(), {action: ''}).then(function(token) {
                        $scope.processing = true;
                        $scope.formFeedback = 'Processing...';
                        $scope.model.captchaToken = token;
                        $http.post("/rpc/membership/register", $scope.model)
                            .then(function (data) {
                                if (data.data.Success == true) {
                                    $scope.formFeedback = '';
                                    window.location.reload();
                                } else {
                                    // vista error
                                    $scope.processing = false;
                                    $scope.formFeedback = 'Error: ' + data.data.Message;
                                }
                            }).catch(function (error) {
                                // our server error
                                $scope.processing = false;
                                $scope.formFeedback = 'Error occurred while trying to submit the form.'
                            });
                    });
                });
            };            
        }
    ]);